import convertQueryString from './convertToQueryString'
import nonEmptyValues from './filterNonEmptyValues'
import serializeQuery from './serializeQuery'
import parseQString from './parseQueryString'
import filterFuncMapping from './filterMapping'
import formatDate from './formatDate'
import redirectAfterAuthUtil, { buildParentUser as buildParentUserUtil } from './postAuthRedirect'
import buildFilterSearchParamsUtil from './buildFilterSearchParams'

export const convertToQueryString = convertQueryString
export const filterNonEmptyValues = nonEmptyValues
export const serializeFiltersForQuery = serializeQuery
export const parseQueryString = parseQString
export const filterMapping = filterFuncMapping
export const FormatDate = formatDate
export const redirectAfterAuth = redirectAfterAuthUtil
export const buildParentUser = buildParentUserUtil
export const buildFilterSearchParams = buildFilterSearchParamsUtil

/**
 * Deep copy object
 *
 * @param {Object} obj - Object to be cloned
 * @returns {Object} - Cloned object
 */
export const cloneObject = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}
